import AOS from "aos";
AOS.init({
    startEvent: 'load',
});
